function displayParty(value) {
  if (value === undefined || value === null || value === '') {
    return 'Not recorded';
  }
  return String(value);
}

export function CustodyCopyHeader({ context }) {
  if (!context) return null;
  return (
    <section className="rounded-2xl border border-evault-border bg-white px-4 py-3">
      <p className="text-sm font-semibold text-umb-neutral-dark">
        Record: {context.record_status}
      </p>
      <p className="mt-1 text-sm text-umb-neutral-dark">
        You are viewing: {context.displayed_copy}
      </p>
      <p className="mt-2 text-xs text-evault-muted">
        Authoritative means the sealed vault record. The file on screen is a watermarked copy.
      </p>
      <dl className="mt-3 grid gap-2 text-xs sm:grid-cols-2">
        <div>
          <dt className="font-semibold uppercase tracking-wide text-evault-muted">
            Document Custodian
          </dt>
          <dd className="mt-0.5 text-umb-neutral-dark">{displayParty(context.custodian_name)}</dd>
        </div>
        <div>
          <dt className="font-semibold uppercase tracking-wide text-evault-muted">
            Document ID
          </dt>
          <dd className="mt-0.5 break-all font-mono text-umb-neutral-dark">
            {displayParty(context.package_file_id)}
          </dd>
        </div>
        <div>
          <dt className="font-semibold uppercase tracking-wide text-evault-muted">
            Source SHA-256
          </dt>
          <dd className="mt-0.5 break-all font-mono text-umb-neutral-dark">
            {displayParty(context.source_sha256)}
          </dd>
        </div>
        <div>
          <dt className="font-semibold uppercase tracking-wide text-evault-muted">
            Control Party
          </dt>
          <dd className="mt-0.5 text-umb-neutral-dark">{displayParty(context.control_party)}</dd>
        </div>
      </dl>
    </section>
  );
}

export function copyBadgeLabel(copyKind) {
  switch (copyKind) {
    case 'REVIEW':
      return 'Review';
    case 'SUPPORTING':
      return 'Supporting';
    case 'REPOSITORY':
      return 'Repository';
    case 'HISTORICAL':
      return 'Historical';
    case 'CERTIFIED_TRUE_COPY':
      return 'Certified';
    case 'NON_AUTHORITATIVE':
      return 'Copy';
    default:
      return null;
  }
}
